module.exports = __webpack_public_path__ + "img/Event.c68aaafb.webp";